import React from 'react';
import clsx from 'clsx';

export interface LinkButtonProps
  extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  variant?: 'primary' | 'secondary';
}

export const LinkButton: React.FC<LinkButtonProps> = ({ className, children, variant = 'primary', ...rest }) => {
  const containerClass = clsx(`fmt__${variant}-button`, 'lds__button', className);

  return (
    <a {...rest} className={containerClass}>
      {children}
    </a>
  );
};

export default LinkButton;
